import React from 'react';

import { useIntl } from 'react-intl';

import { BarToolTip } from '../BarToolTip';

const AudienceBuilder = () => {
  const { messages } = useIntl();

  return (
    <BarToolTip title={messages.locales.headers.linkManager}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33332 10.8333C8.6912 11.3118 9.14779 11.7077 9.67212 11.9941C10.1964 12.2806 10.7762 12.4509 11.3722 12.4936C11.9682 12.5363 12.5663 12.4503 13.1261 12.2415C13.6859 12.0327 14.1943 11.7059 14.6167 11.2833L17.1167 8.78334C17.8757 7.9975 18.2956 6.94499 18.2861 5.85251C18.2766 4.76002 17.8384 3.71497 17.0659 2.94243C16.2934 2.1699 15.2483 1.7317 14.1558 1.7222C13.0633 1.71271 12.0108 2.13269 11.225 2.89168L9.79166 4.31668M11.6667 9.16668C11.3088 8.68824 10.8522 8.29236 10.3279 8.00589C9.80354 7.71943 9.22373 7.54908 8.62778 7.5064C8.03183 7.46372 7.43367 7.54971 6.87387 7.75853C6.31407 7.96735 5.80573 8.29412 5.38332 8.71668L2.88332 11.2167C2.12433 12.0025 1.70436 13.055 1.71385 14.1475C1.72334 15.24 2.16155 16.2851 2.93408 17.0576C3.70661 17.8301 4.75167 18.2683 5.84415 18.2778C6.93664 18.2873 7.98915 17.8673 8.77499 17.1083L10.2 15.6833" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </BarToolTip>
  );
};

export default AudienceBuilder;
